<template>
  <div class="terms-page">
    <!-- Header with back navigation -->
    <header class="header">
      <div class="header-content">
        <v-btn
          icon="mdi-arrow-left"
          variant="text"
          color="white"
          @click="goBack"
          class="back-button"
        />
        <img 
          src="/assets/logo-text-only.png" 
          alt="Youngpro Logo" 
          class="logo-text"
          @click="goHome" 
        />
        <div class="spacer"></div>
      </div>
    </header>

    <!-- Main content -->
    <div class="content-container">
      <div class="content">
        <h1 class="page-title">Terms of Service 이용약관</h1>
        
        <div class="terms-content">
          <section class="terms-section">
            <h2>제1조 (목적)</h2>
            <p>
              본 약관은 인터루드(이하 "회사")가 운영하는 Youngpro 멤버십 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무, 책임 및 서비스 이용 조건을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section class="terms-section">
            <h2>제2조 (정의)</h2>
            <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            <ol>
              <li>서비스: 회사가 제공하는 비즈니스 영어 학습 및 컨설팅 관련 온라인 콘텐츠, 실시간 세션, 커뮤니티 등의 모든 디지털 기반 서비스를 의미합니다.</li>
              <li>회원: 본 약관에 동의하고 회사가 제공하는 서비스를 이용하기 위해 가입한 자를 의미합니다.</li>
              <li>멤버십: 정기 결제를 통해 월 단위로 제공되는 구독형 서비스 이용 권한을 의미합니다.</li>
              <li>콘텐츠: 서비스 내에서 제공되는 영상, 라이브 세션, 파일 자료 등 모든 학습 콘텐츠를 의미합니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제3조 (서비스의 제공 및 변경)</h2>
            <p>회사는 다음 서비스를 제공합니다.</p>
            <ol>
              <li>비즈니스 영어 마스터클래스 콘텐츠</li>
              <li>주간 라이브 컨설팅 세션</li>
              <li>실전 피드백 서비스</li>
              <li>전용 커뮤니티 이용</li>
              <li>회사가 별도로 정하는 학습 자료 제공</li>
            </ol>
            <p>회사는 서비스 품질 향상 또는 운영상 필요한 경우 서비스 내용을 변경할 수 있으며, 중요한 변경은 사전에 고지합니다.</p>
          </section>

          <section class="terms-section">
            <h2>제4조 (멤버십 및 결제)</h2>
            <ol>
              <li>멤버십은 정기 구독 방식으로 제공되며, 기본 요금은 월 98,000원(VAT 포함)입니다.</li>
              <li>모든 결제는 회사가 지정한 결제대행사인 Toss Payments를 통해 처리됩니다.</li>
              <li>정기 결제는 회원이 가입한 날을 기준으로 매월 자동 청구되며, 회원이 해지를 요청하지 않는 한 계속 갱신됩니다.</li>
              <li>회사는 회원의 카드 정보 등 결제정보를 직접 보관하지 않습니다.</li>
              <li>결제 실패가 반복될 경우 회사는 서비스 이용을 제한할 수 있습니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제5조 (회원의 의무)</h2>
            <p>회원은 다음 각 호의 행위를 해서는 안 됩니다.</p>
            <ol>
              <li>타인의 정보를 도용하거나 부정하게 사용하는 행위</li>
              <li>회사가 제공하는 콘텐츠를 무단으로 복제, 배포, 전송, 판매하는 행위</li>
              <li>서비스 운영을 고의로 방해하는 행위</li>
              <li>다른 회원 또는 제3자에게 피해를 주는 행위</li>
              <li>약관 또는 관련 법령을 위반하는 행위</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제6조 (지식재산권)</h2>
            <ol>
              <li>서비스 내 모든 콘텐츠의 저작권 및 지식재산권은 회사에 귀속됩니다.</li>
              <li>회원은 회사의 사전 동의 없이 콘텐츠를 복제, 출판, 전송, 배포, 방송 등으로 사용할 수 없습니다.</li>
              <li>회사는 무단 도용, 유출, 공유가 확인될 경우 민형사상 조치를 취할 수 있습니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제7조 (면책사항)</h2>
            <ol>
              <li>회사는 천재지변, 정전, 기간통신사업자의 장애 등 불가항력으로 인한 서비스 중단에 대해 책임을 지지 않습니다.</li>
              <li>회사는 회원의 귀책사유로 인한 서비스 장애에 대해 책임을 지지 않습니다.</li>
              <li>회사는 회원 간 또는 회원과 제3자 간 발생한 분쟁에 개입하지 않으며, 이에 따른 책임을 부담하지 않습니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제8조 (환불 및 자동결제 해지)</h2>
            <ol>
              <li>환불 및 자동결제 해지는 회사의 환불정책에 따릅니다.</li>
              <li>회원은 info@youngpro.club 이메일을 통해 환불 또는 정기결제 해지를 요청할 수 있습니다.</li>
              <li>환불은 결제된 월 내에 요청한 경우에 한하여 전액 환불됩니다.</li>
              <li>월이 경과한 후에는 환불이 불가능합니다.</li>
              <li>일할 환불, 부분 환불 등은 제공되지 않습니다.</li>
              <li>환불이 완료되면 해당 월 서비스 이용 권한은 즉시 종료됩니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제9조 (분쟁 해결 및 준거법)</h2>
            <ol>
              <li>본 약관에 명시되지 않은 사항은 관련 법령 및 소비자분쟁해결기준에 따릅니다.</li>
              <li>서비스 이용과 관련된 회사와 회원 간의 분쟁은 상호 협의를 통해 원만히 해결하도록 노력합니다.</li>
              <li>협의가 이루어지지 않을 경우 대한민국 법을 준거법으로 하고, 관할 법원은 민사소송법에 따릅니다.</li>
            </ol>
          </section>
        </div>

        <div class="last-updated">
          <p>시행일자: 2025년 10월 1일</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <FooterDefault current-page="terms" />
  </div>
</template>

<script>
import FooterDefault from '@/components/FooterDefault.vue';

export default {
  name: 'TermsOfService',
  components: {
    FooterDefault
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push('/');
    },
    goToRefundPolicy() {
      this.$router.push('/refund-policy');
    },
    goToPrivacyPolicy() {
      this.$router.push('/privacy-policy');
    }
  }
};
</script>

<style scoped>
.terms-page {
  background-color: var(--bg);
  color: var(--text-primary);
  height: 100vh;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-scrollbar: none;
}

@media (max-width: 700px) {
  .terms-page {
    max-height: 92vh; /* fallback */
  max-height: calc(100dvh - 6vh); /* URL-bar-safe (see HomePage) */
  }
}

.header {
  height: 6vh;
  width: 100%;
  background-color: var(--bg);
  border-bottom: 1px solid var(--hairline);
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.back-button {
  flex-shrink: 0;
}

.logo-text {
  height: 24px;
  cursor: pointer;
  margin: 0 auto;
}

.spacer {
  width: 40px;
  flex-shrink: 0;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: calc(100vh - 6vh);
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
  color: var(--text-primary);
}

.terms-content {
  margin-bottom: 40px;
}

.terms-section {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--hairline);
}

.terms-section:last-child {
  border-bottom: none;
}

.terms-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--accent-strong);
}

.terms-section p {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 12px;
}

.terms-section ol {
  padding-left: 20px;
  margin: 12px 0;
}

.terms-section li {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.terms-section ul {
  padding-left: 20px;
  margin: 12px 0;
}

.terms-section ul li {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.last-updated {
  text-align: center;
}

.last-updated p {
  font-size: 14px;
  color: var(--text-tertiary);
}

@media (max-width: 768px) {
  .page-title {
    font-size: 28px;
  }
  
  .terms-section h2 {
    font-size: 18px;
  }
  
  .terms-section p,
  .terms-section li {
    font-size: 14px;
  }
  
  .content-container {
    padding: 20px;
    min-height: calc(100vh - 6vh);
  }
}
</style>
